import React from 'react';
import Alert from '@material-ui/lab/Alert';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
export default function Complete({ msg, msgFr }) {
    const { t, i18n } = useTranslation();
    return (
        <div>
            <Alert>{t('complete.title')}</Alert>
            <br />
            <Typography
                variant="body2"
                component="p"
                dangerouslySetInnerHTML={{ __html: i18n.language === 'fr' && msgFr !== '' ? msgFr : msg }}>
            </Typography>
            <br />
            <br />
            <br />
        </div>
    );
}
